<template>
  <li :class="{ 'uk-active': isActive }">
    <slot></slot>
  </li>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
      type: String
    },
    selected: {
      required: false,
      type: Boolean
    },
    icon: {
      required: true,
      type: String
    },
    index: {
      required: true,
      type: Number
    },
    tooltip: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      isActive: false
    }
  },

  mounted() {
    const listItems = this.$el.querySelectorAll('li')
    if (listItems.length) {
      listItems.forEach(e => {
        //const match = e.querySelector('[href="' + this.$route.path + '"]')
        if (this.$route.path.startsWith(e.querySelector('a').getAttribute('href'))) {
          this.isActive = true
          //match.parentNode.classList.add('uk-active')
        }
      })
    }
  },
  computed: {
    href() {
      return '#' + this.name.toLowerCase().replace(/ /g, '-')
    }
  }
}
</script>
